<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 12 15">
    <path
      d="M2.21528 6.25273H6.18121C6.76556 6.25273 7.32598 6.0206 7.73918 5.6074C8.15238 5.1942 8.38451 4.63378 8.38451 4.04943C8.38451 3.46508 8.15238 2.90466 7.73918 2.49147C7.32598 2.07827 6.76556 1.84613 6.18121 1.84613H2.21528V6.25273ZM11.0285 10.2187C11.0285 10.7395 10.9259 11.2552 10.7266 11.7364C10.5273 12.2175 10.2351 12.6547 9.86687 13.023C9.4986 13.3913 9.0614 13.6834 8.58023 13.8827C8.09906 14.082 7.58335 14.1846 7.06253 14.1846H0.943657C0.672474 14.1846 0.452637 13.9648 0.452637 13.6936V0.574517C0.452637 0.303334 0.672474 0.0834961 0.943657 0.0834961H6.18121C6.95762 0.0835286 7.71693 0.311452 8.36501 0.739002C9.01309 1.16655 9.52142 1.77492 9.82696 2.48868C10.1325 3.20243 10.2218 3.99017 10.0839 4.75422C9.94588 5.51826 9.58668 6.22501 9.05079 6.78681C9.65242 7.13519 10.1519 7.63567 10.499 8.23803C10.8461 8.84039 11.0287 9.52345 11.0285 10.2187ZM2.21528 8.01537V12.422H7.06253C7.64688 12.422 8.2073 12.1898 8.6205 11.7766C9.0337 11.3634 9.26583 10.803 9.26583 10.2187C9.26583 9.63432 9.0337 9.0739 8.6205 8.6607C8.2073 8.2475 7.64688 8.01537 7.06253 8.01537H2.21528Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
